import React from "react"
import constants from "../../constants"
import { capitalize } from "../../utils/permissions-mapping"

const profileDescriptions = constants.profile.descriptions

const mapPermissions = (list) =>
  list
    .map((profileItem) => {
      const { info, desc } = profileItem
      return profileDescriptions[info] || desc
    })
    .join(", ")

function CustomPermissions({ sharedInformation }) {
  const permissions = sharedInformation.map(({ info }) => info)
  const profile = permissions.includes("profile") ? (
    <>
      <li key="profile" className="custom-list-heading">
        <b>Open your account by getting your personal data including:</b>
      </li>
      <p className="custom-list-desc">
        {capitalize(
          mapPermissions(
            sharedInformation.find((item) => item.info === "profile").list
          )
        )}
      </p>
    </>
  ) : (
    ""
  )
  const login = permissions.includes("login") ? (
    <>
      <li key="login" className="custom-list-heading">
        <b>Log in with your Maya account seamlessly</b>
      </li>
      <p className="custom-list-desc">
        Log in and remain connected when you use their service on Maya
      </p>
    </>
  ) : (
    ""
  )
  const purchase = permissions.includes("purchase") ? (
    <li key="purchase" className="custom-list-heading">
      <b>Allow you to withdraw from your Maya wallet for your transactions</b>
    </li>
  ) : (
    ""
  )
  const topup = permissions.includes("topup") ? (
    <li key="topup" className="custom-list-heading">
      <b>Allow you to deposit to your Maya wallet for your transactions</b>
    </li>
  ) : (
    ""
  )
  const balance = permissions.includes("balance") ? (
    <li key="balance" className="custom-list-heading">
      <b>View your Maya balance</b>
    </li>
  ) : (
    ""
  )

  return (
    <div className="container">
      <ul>
        {profile}
        {login}
        {purchase}
        {topup}
        {balance}
      </ul>
    </div>
  )
}

export default CustomPermissions
